import {
  ADD_FILTER,
  SET_FILTER,
  SET_FILTER_OPERATOR,
  SET_FILTER_MODEL_OPERATOR,
  UNSET_FILTER,
  CLEAR_FILTERS
} from 'app/actions/types';

export const addFilter = params => dispatch => {
  const {
    resource,
    field,
    filterClass,
    filterType
  } = params;

  dispatch({
    type: ADD_FILTER,
    payload: {
      resource,
      field,
      filterClass,
      filterType
    }
  });
}

export const setFilter = params => dispatch => {
  const {
    resource,
    field,
    filterIndex,
    filterClass,
    filterType,
    value,
    operator
  } = params;

  if (!value) {
    dispatch({
      type: UNSET_FILTER,
      payload: {
	resource,
	field,
	filterIndex
      }
    });
    return;
  }

  dispatch({
    type: SET_FILTER,
    payload: {
      resource,
      field,
      filterIndex,
      filterClass,
      filterType,
      value,
      operator
    }
  });
}

export const setFilterOperator = params => dispatch => {
  const {
    resource,
    field,
    filterIndex,
    operator
  } = params;

  dispatch({
    type: SET_FILTER_OPERATOR,
    payload: {
      resource,
      field,
      filterIndex,
      operator
    }
  });
}

export const setFilterModelOperator = params => dispatch => {
  const {
    resource,
    operator
  } = params;

  dispatch({
    type: SET_FILTER_MODEL_OPERATOR,
    payload: {
      resource,
      operator
    }
  });
}

export const unsetFilter = params => dispatch => {
  const {
    resource,
    field,
    filterIndex
  } = params;

  dispatch({
    type: UNSET_FILTER,
    payload: {
      resource,
      field,
      filterIndex
    }
  });
}

export const clearFilters = params => dispatch => {
  const {
    resource
  } = params;

  dispatch({
    type: CLEAR_FILTERS,
    payload: {
      resource
    }
  });
}
